import * as types from '../mutation-types'

export default {
  namespaced: true,
  state: {
    title: '',
    action: null,
    processing: false,
    data: null
  },
  mutations: {
    [types.TOOLBAR_SET_TITLE] (state, title) {
      state.title = title
    },
    [types.TOOLBAR_SET_ACTION] (state, name) {
      state.action = name
    },
    [types.TOOLBAR_INIT_ACTION] (state) {
      state.action = null
      state.processing = false
    },
    [types.TOOLBAR_START_PROCESSING] (state) {
      state.processing = true
    },
    [types.TOOLBAR_END_PROCESSING] (state) {
      state.processing = false
    },
    [types.TOOLBAR_SET_DATA] (state, data) {
      state.data = data
    }
  },
  actions: {
    setTitle ({ commit }, title) {
      commit(types.TOOLBAR_SET_TITLE, title)
    },
    setAction ({ commit }, name) {
      commit(types.TOOLBAR_SET_ACTION, name)
    },
    initAction ({ commit }) {
      commit(types.TOOLBAR_INIT_ACTION)
    },
    processing ({ commit }, val) {
      commit(
        val ? types.TOOLBAR_START_PROCESSING : types.TOOLBAR_END_PROCESSING
      )
    },
    setData ({ commit }, data) {
      commit(types.TOOLBAR_SET_DATA, data)
    }
  },
  getters: {
    title: (state) => state.title
  }
}
